import img_recruitment from "../../assets/images/img_recruitment.webp";
import ic_location from "../../assets/icons/ic_location.svg";
import ic_timer_pause from "../../assets/icons/ic_timer_pause.svg";
import { Link } from "react-router-dom";
import { formatDate, getRangeSalary } from "./ultil";

export default function RecruitmentGridItem({ item }) {
  return (
    <Link
      to={`/recruitment/detail/${item.slug}/${item.id}`}
      className="rounded-lg relative border-[1px] overflow-hidden block border-gray-300 hover:border-[#27C6FF] hover:shadow-[0px_4px_10px_0px_rgba(0,0,0,0.12)] group"
      style={{ transition: "all 0.3s" }}
    >
      {item.isHot && (
        <div className="absolute text-white px-5 py-[6px] text-[14px] top-2 left-2 rounded-2xl bg-[#FF3F4F]">
          Hot
        </div>
      )}
      <img src={img_recruitment} className="w-full h-[213px]" />
      <div className="px-4 py-5">
        <p
          className="font-semibold line-clamp-2 min-h-[3rem] cursor-pointer group-hover:text-[#27C6FF]"
          style={{ transition: "all 0.3s" }}
        >
          {item.title}
        </p>
        <p className="font-semibold mt-2 text-[#1C9BDB] text-[18px]">
          {getRangeSalary(
            item?.startSalary.toString(),
            item?.endSalary.toString(),
            item?.salaryLevel
          )}
        </p>
        <div className="flex gap-[10px] items-center mt-2">
          <img src={ic_location} className="w-5 h-5" />
          <p className="text-[#606060] font-normal">Hà nội</p>
        </div>
        <div className="flex gap-[10px] items-center mt-2">
          <img src={ic_timer_pause} className="w-5 h-5" />
          <p className="text-[#606060] font-normal">
            {formatDate(item.deadlineTime)}
          </p>
        </div>
      </div>
    </Link>
  );
}
